<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ form.modal.title }}</h4>
        </div>
        <div class="modal-body">
          <div class="panel-body">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form
                  class="form-inline search-fields"
                  @submit.prevent="form.onSiteSearch('siteId')"
                >
                  <div class="form-group">
                    <select
                      class="form-control"
                      id="searchField"
                      name="searchField"
                      v-model="form.siteSearch.field"
                    >
                      <option value="site">Site</option>
                      <option value="zone">Zone</option>
                      <option value="location">Location</option>
                      <option value="route">Route</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input
                      type="search"
                      placeholder="search sites"
                      class="form-control"
                      v-model="form.siteSearch.term"
                    />
                    <span
                      class="input-group-addon pointer"
                      v-on:click="form.onSiteSearch('siteId')"
                      title="search"
                      ><i class="fa fa-search"></i
                    ></span>
                  </div>
                  <i
                    class="fa fa-spinner fa-spin"
                    v-if="siteSearch.loading"
                  ></i>
                  <button
                    type="button"
                    class="btn btn-default ml-20"
                    v-if="!siteSearch.loading"
                    v-on:click="newSite"
                  >
                    Create new site
                  </button>
                </form>
              </div>
            </div>
          </div>

          <form
            @submit.prevent="form.onSubmit"
            @keydown="form.errors.clear($event.target.id)"
          >
            <input type="hidden" name="id" v-model="form.data.id" />

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('siteId') }"
            >
              <label class="control-label">Site Name or Id</label>
              <div class="form-group">
                <select
                  class="form-control"
                  v-model="form.data.siteId"
                  v-on:change="setSelected"
                >
                  <option
                    v-for="item in siteSearch.sites"
                    v-bind:value="item.id"
                    >{{ item.attributes.name }}</option
                  >
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('siteId')"
                v-text="form.errors.get('siteId')"
              ></span>
            </div>

            <div class="site-details">
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2">
                  <strong>Name:</strong> {{ siteSearch.selected.name }}
                </div>
                <div class="col-xs-12 col-sm-4">
                  <strong>Address:</strong> {{ siteSearch.selected.address }},
                  {{ siteSearch.selected.city }},
                  {{ stateName(siteSearch.selected.stateId) }}
                  {{ siteSearch.selected.zip }}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2">
                  <strong>Zone:</strong>
                  {{ zoneName(siteSearch.selected.zoneId) }}
                </div>
                <div class="col-xs-12 col-sm-4">
                  <strong>Route:</strong>
                  {{ routeName(siteSearch.selected.routeId) }}
                </div>
              </div>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('trapNumber') }"
            >
              <label class="control-label">Trap Name or Number</label>
              <input
                type="text"
                class="form-control"
                id="trapNumber"
                v-model="form.data.trapNumber"
              />
              <span
                class="help-block"
                v-if="form.errors.has('trapNumber')"
                v-text="form.errors.get('trapNumber')"
              ></span>
            </div>

            <div
              class="checkbox"
              :class="{ 'has-error': form.errors.has('isActive') }"
            >
              <label>
                <input
                  type="checkbox"
                  id="isActive"
                  v-model="form.data.isActive"
                />
                Active</label
              >
              <span
                class="help-block"
                v-if="form.errors.has('isActive')"
                v-text="form.errors.get('isActive')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('countyId') }"
            >
              <label class="control-label"
                >County <span class="optional">(optional)</span></label
              >
              <div class="form-group">
                <select class="form-control" v-model="form.data.countyId">
                  <option></option>
                  <option v-for="item in counties" v-bind:value="item.id">{{
                    item.attributes.name
                  }}</option>
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('countyId')"
                v-text="form.errors.get('countyId')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('altitude') }"
            >
              <label class="control-label"
                >Altitude <span class="optional">(optional)</span></label
              >
              <input
                type="text"
                class="form-control"
                id="altitude"
                v-model="form.data.altitude"
              />
              <span
                class="help-block"
                v-if="form.errors.has('altitude')"
                v-text="form.errors.get('altitude')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('trapTypeId') }"
            >
              <label class="control-label">Trap Type</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.trapTypeId">
                  <option></option>
                  <option v-for="item in trapTypes" v-bind:value="item.id">{{
                    item.attributes.trap
                  }}</option>
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('trapTypeId')"
                v-text="form.errors.get('trapTypeId')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('trapNightId') }"
            >
              <label class="control-label"
                >Trap Night <span class="optional">(optional)</span></label
              >
              <div class="form-group">
                <select class="form-control" v-model="form.data.trapNightId">
                  <option></option>
                  <option v-for="item in trapNights" v-bind:value="item.id">{{
                    item.attributes.name
                  }}</option>
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('trapNightId')"
                v-text="form.errors.get('trapNightId')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('trapTeamId') }"
            >
              <label class="control-label"
                >Trap Team <span class="optional">(optional)</span></label
              >
              <div class="form-group">
                <select class="form-control" v-model="form.data.trapTeamId">
                  <option></option>
                  <option v-for="item in trapTeams" v-bind:value="item.id">{{
                    item.attributes.name
                  }}</option>
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('trapTeamId')"
                v-text="form.errors.get('trapTeamId')"
              ></span>
            </div>

            <div
              class="checkbox"
              :class="{ 'has-error': form.errors.has('isMandatory') }"
            >
              <label>
                <input
                  type="checkbox"
                  id="isMandatory"
                  v-model="form.data.isMandatory"
                />
                Site is Mandatory</label
              >
              <span
                class="help-block"
                v-if="form.errors.has('isMandatory')"
                v-text="form.errors.get('isMandatory')"
              ></span>
            </div>

            <loading-button
              :loading="form.loading"
              class="btn btn-primary"
              :disabled="form.errors.any()"
              >Save</loading-button
            >
            <button type="button" class="btn btn-default" data-dismiss="modal">
              cancel
            </button>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import LoadingButton from '@/components/loading-button';
import SitesService from '@/services/SitesService';

export default {
  name: 'trap-site-form',

  props: ['form', 'continueToCreateAdultSurv'],

  components: {
    LoadingButton,
  },

  data() {
    return {
      siteSearch: this.$store.getters.siteSearch,
    };
  },

  methods: {
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    routeName(id) {
      return this.$store.getters.routeNameById(id);
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    setSelected() {
      this.$store.dispatch('setSiteSearchSelected', this.form.data.siteId);
    },
    newSite() {
      this.form.hideEdit();
      this.$router.push({ name: 'data-sites-new' });
    },
  },

  computed: {
    sites() {
      return this.$store.getters.sites;
    },
    counties() {
      return this.$store.getters.counties;
    },
    municipalities() {
      return this.$store.getters.municipalities;
    },
    trapTeams() {
      return this.$store.getters.trapTeams;
    },
    trapNights() {
      return this.$store.getters.trapNights;
    },
    trapTypes() {
      return this.$store.getters.trapTypes;
    },
    zones() {
      return this.$store.getters.zones;
    },
  },

  mounted() {
    this.form.siteSearch.service = SitesService;
  },
};
</script>
